var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.99956 20H14.9996C16.8852 20 17.828 20 18.4138 19.4142C18.8853 18.9427 18.9773 18.2398 18.9952 17H5.00391C5.02184 18.2398 5.1138 18.9427 5.58535 19.4142C6.17113 20 7.11394 20 8.99956 20Z",
    fill: "#00A86B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6H9C7.11438 6 6.17157 6 5.58579 6.58579C5 7.17157 5 8.11438 5 10V16C5 16.3677 5 16.6996 5.00435 17H18.9957C19 16.6996 19 16.3677 19 16V10C19 8.11438 19 7.17157 18.4142 6.58579C17.8284 6 16.8856 6 15 6H12.75V10.9726L13.4306 10.1786C13.7001 9.86408 14.1736 9.82766 14.4881 10.0972C14.8026 10.3668 14.839 10.8403 14.5694 11.1548L12.5694 13.4881C12.427 13.6543 12.2189 13.75 12 13.75C11.7811 13.75 11.573 13.6543 11.4306 13.4881L9.43056 11.1548C9.16099 10.8403 9.19741 10.3668 9.51191 10.0972C9.8264 9.82766 10.2999 9.86408 10.5694 10.1786L11.25 10.9726V6Z",
    fill: "#00A86B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.1111 3H5.88889C3.74112 3 2 4.79998 2 7.02036C2 8.92457 3.28058 10.5196 5 10.9352V10C5 8.11438 5 7.17157 5.58579 6.58579C6.17157 6 7.11438 6 9 6H11.25H12.75H15C16.8856 6 17.8284 6 18.4142 6.58579C19 7.17157 19 8.11438 19 10V10.9352C20.7194 10.5196 22 8.92457 22 7.02036C22 4.79998 20.2589 3 18.1111 3Z",
    fill: "#00A86B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveW);
export default __webpack_public_path__ + "static/media/active-w.c6f846de6e74d6728fef8ce5266c7025.svg";
export { ForwardRef as ReactComponent };